<template>
    <div class="contact_us">
    <img
      src="../../assets/contactus/banner.png"
      alt
      style="width:100%;height:22.5rem;overflow:hidden; object-fit: cover;"/>
     <h3>{{msg}}</h3>

    <div class="div_contact">
    <span>
        联系方式：business@yongxintechhk.com<br/>联系地址：S8 9F W LUXE 5 ON YIU STREET SHA TIN NT HK
    </span>
    </div>

    <div id="container">
    <img
      src="../../assets/contactus/img.png"
      alt
      style="width: 96%; height: 100%;"
    />
    </div>

    </div>
</template>
<style scoped>
.contact_us{

   min-height: 100%;
}
#container{
    width: 42.625rem;
    height:25.6875rem;
    margin-top: 3.125rem;
    margin-bottom: 3.125rem;
    display: inline-block;
}


h3 {
  padding-top: 4.375rem;
  padding-bottom: 3rem;
  color: #1A1A1A;
  font-size: 2.25rem;
  line-height: 3.75rem;
}
.div_contact{
  margin-left: 4.6875rem;
  margin-right: 4.6875rem;
}
span{
  color: #777;
  font-size:1.5rem;
  line-height: 2.25rem;
}
</style>
<script>
export default {

    data () {
    return {
        msg:'联系我们'
    };
    },

    mounted () {
        // this.createImageBitmap();
    },

    methods:{
    //  createImageBitmap () {
    //     var map = new BMapGL.Map('container');
    //     var marker = new BMapGL.Marker(new BMapGL.Point(113.893496,22.556749)); // 创建点
    //     map.centerAndZoom(new BMapGL.Point(113.893496,22.556749), 17);
    //     map.enableScrollWheelZoom(true);
    //     map.addOverlay(marker);
    //  },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mobile/ContactUs.vue